/**
 *
 * TagsFilter
 *
 */
import { TagsPicker } from 'app/components/pickers/AutocompletePickers/TagsPicker';
import * as React from 'react';
import { translations } from 'locales/translations';
import { useTranslation } from 'react-i18next';
import { Entity } from 'types/common';
import { IFilterComponentProps } from '../IFilterComponentProps';

export const TagsFilter = (props: IFilterComponentProps) => {
  const handleOnChange = (value: Entity<number>[]) => {
    props.onChange(value);
  };
  const { t } = useTranslation();
  return (
    <TagsPicker
      value={props.value ?? []}
      onChange={handleOnChange}
      size="small"
      isOpen={props.open}
      placeholder={t(translations.AllValues)}
      filterSelectedOptions
      ariaLabel={props.label}
      id={props.id}
      predicates={props.predicates}
      onPickerOpen={props.onOpen}
    />
  );
};
export default TagsFilter;
